import WebsitesModel from '#model/WebsitesModel'
import { useApiClient } from '#context/ApiContext'
import { useNotifications } from '#context/NotificationContext'
import { useInstanceOf } from 'eilmer-mvvm/react'

export default class WebsitesViewModel {

  constructor(apiClient, notificationsProvider) {
    this.model = new WebsitesModel(apiClient)
    this.notifications = notificationsProvider
    this.entity = new WebsitesModel.Website()
    this.editing = false
    this.loadEntities()
  }

  async loadEntities() {
    try {
      this.entities = await this.model.getWebsites()
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  doEditEntity(entity) {
    this.entity = new WebsitesModel.Website(entity)
    this.editing = true
  }

  doCancelEdit() {
    this.editing = false
  }

  async doSaveEntity(entity) {
    try {
      if (entity.isNew()) {
        const result = await this.model.createWebsite(entity)
        this.editing = false
        this.loadEntities()
        return result
      } else {
        const result = await this.model.updateWebsite(entity)
        this.editing = false
        this.loadEntities()
        return result
      }
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  async doDeleteEntity(entity) {
    if (await this.notifications.confirm('Are you sure you\'d like to delete this entity?')) {
      try {
        const result = await this.model.deleteWebsite(entity)
        this.loadEntities()
        return result
      } catch (err) {
        console.error(err)
        this.notifications.error(err.message)
      }
    }
  }

  get fields() {
    return [
      { key: 'website_id', label: "ID", _style: { width: '6%'}, _classes: 'bg-light text-dark' },
      { key: 'name', _style: { width: '25%'} },
      { key: 'hostname' },
      {
        key: 'actions',
        label: '',
        _style: { width: '70px' },
        filter: false
      }
    ]
  }

}

WebsitesViewModel.useInstance = function() {
  return useInstanceOf(WebsitesViewModel, useApiClient(), useNotifications())
}
